<script setup>
import {defineModel} from 'vue'
import SettingsSvg from "@/components/UI/svg/SettingsSvg.vue";
import ConnectionsSvg from "@/components/UI/svg/ConnectionsSvg.vue";
import FileSvg from "@/components/UI/svg/FileSvg.vue";


const state = defineModel()


function changeState(value) {
    state.value = value
}

</script>

<template>
    <div class="h-20 absolute bottom-0 border-t border-t-gray-200 flex justify-evenly bg-white">
        <div class="h-full w-20 flex flex-col items-center justify-center hover:bg-gray-100 cursor-pointer"
             v-on:click="changeState('connections')"
        >
            <ConnectionsSvg class="size-8 mb-1"
                       :class="{
                            'fill-blue-500': state === 'connections',
                            'fill-gray-500': state !== 'connections'
                       }"
            />
            <div
                class="font-bold  text-xs"
                :class="{
                    'text-blue-500': state === 'connections',
                    'text-gray-500': state !== 'connections'
                }"
            >
                Соединения
            </div>
        </div>
        <div class="h-full w-20 flex flex-col items-center justify-center hover:bg-gray-100 cursor-pointer"
             v-on:click="changeState('files')"
        >
            <FileSvg class="size-8 stroke-2 mb-1"
                       :class="{
                            'stroke-blue-500': state === 'files',
                            'stroke-gray-500': state !== 'files'
                       }"
            />
            <div
                class="font-bold text-xs"
                :class="{
                    'text-blue-500': state === 'files',
                    'text-gray-500': state !== 'files'
                }"
            >
                Файлы
            </div>
        </div>
        <div class="h-full w-20 flex flex-col items-center justify-center hover:bg-gray-100 cursor-pointer"
             v-on:click="changeState('settings')"
        >
            <SettingsSvg class="size-8 stroke-2 mb-1"
                       :class="{
                            'stroke-blue-500': state === 'settings',
                            'stroke-gray-500': state !== 'settings'
                       }"
            />
            <div
                class="font-bold  text-xs"
                :class="{
                    'text-blue-500': state === 'settings',
                    'text-gray-500': state !== 'settings'
                }"
            >
                Настройки
            </div>
        </div>



    </div>
</template>

<style scoped>

</style>